import { ChatMessage } from "myfitworld-model";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useUserProvider } from "./UserProvider";
import { subscribeToCountUnreadMessages } from "src/api/messagesApi";

export const MessagesContext = createContext<{
    unreadUserCountMessages: Map<string, number>,
    unreadCountMessages: number,
}|undefined>(undefined);

export interface Conversation {
  messages: ChatMessage[];
  unread: number;
}

export interface ChatsMap {
  [conversationId: string]: Conversation;
}

export const MessagesProvider = ({ children }: {children: any}) => {
    const {user} = useUserProvider();
    const [unreadUserCountMessages, setUnreadUserCountMessages] = useState<Map<string,number>>(new Map());
    const [unreadCountMessages, setUnreadCountMessages] = useState(0);
    useEffect(() => {
        if (!user?.id) return;
        const unsubscribe = subscribeToCountUnreadMessages({ userId: user.id, onUnreadUserCountChange: setUnreadUserCountMessages, onUnreadTotalCountChange: setUnreadCountMessages});
        return () => unsubscribe();
    }, [user]);

  return (
    <MessagesContext.Provider
      value={{
        unreadUserCountMessages,
        unreadCountMessages,
      }}
    >
    {children}
    </MessagesContext.Provider>
  );
};

export const useMessagesProvider = () => {
    const context = useContext(MessagesContext);
    if (context === undefined) {
      throw new Error(
        'useMessagesProvider must be used within a MessagesProvider'
      );
    }
    return context;
};